import axios from 'axios';

export default async function getAllLocationsWhereUserIsGuest({
  accessToken,
  userId,
  page = 0,
  pageSize = 100,
  query = '',
  setTokenLikeExpired,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_GUESTS_API_URL}/user-location/${userId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();
    console.log(err.response);
  }
}
